module.exports = __webpack_public_path__ + "static/media/correct.70454ee3.mp3";